import { useState, useEffect } from 'react';
import PoliticianCard from './PoliticianCard';
import { api } from './api';

function HomePage() {
    const [unhealthiestPoliticians, setUnhealthiestPoliticians] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUnhealthiestPoliticians = async () => {
            setLoading(true);
            const data = await api.getUnhealthiestPoliticians(10);
            setUnhealthiestPoliticians(data);
            setLoading(false);
        };

        fetchUnhealthiestPoliticians();
    }, []);

    if (loading) {
        return (
            <div className="homepage">
                <div className="loading">Loading Political Health Data...</div>
            </div>
        );
    }

    return (
        <div className="homepage">
            {/* Welcome Section */}
            <section className="welcome-section">
                <div className="welcome-content">
                    <h2>Welcome to Political Health Tracker</h2>
                    <p>
                        Monitor the wellness of our democracy by tracking the health scores
                        of federal politicians across all branches of government.
                    </p>
                    <div className="welcome-stats">
                        <div className="welcome-stat">
                            <span className="stat-number">{unhealthiestPoliticians.length}</span>
                            <span className="stat-label">Politicians Tracked</span>
                        </div>
                        <div className="welcome-stat">
                            <span className="stat-number">
                                {unhealthiestPoliticians.filter(p => p.healthScore < 50).length}
                            </span>
                            <span className="stat-label">Critical Health</span>
                        </div>
                        <div className="welcome-stat">
                            <span className="stat-number">3</span>
                            <span className="stat-label">Branches Covered</span>
                        </div>
                    </div>
                    <div className="navigation-hint">
                        <p>👆 Use the menu button above to navigate between branches</p>
                    </div>
                </div>
            </section>

            {/* Alert Section */}
            <section className="alert-section">
                <div className="alert-header">
                    <h2>🚨 Political Health Alert</h2>
                    <p>These politicians have the lowest health scores and need our attention</p>
                </div>

                <div className="unhealthiest-grid">
                    {unhealthiestPoliticians.map((politician, index) => (
                        <div key={politician.id} className="unhealthy-card-wrapper">
                            <div className="rank-badge">#{index + 1}</div>
                            <PoliticianCard politician={politician} />
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}

export default HomePage;